import { render, staticRenderFns } from "./how-to-pay-detail.vue?vue&type=template&id=ad05f572"
import script from "./how-to-pay-detail.vue?vue&type=script&lang=js"
export * from "./how-to-pay-detail.vue?vue&type=script&lang=js"
import style0 from "./how-to-pay-detail.vue?vue&type=style&index=0&id=ad05f572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports